import { Icon, DatePicker, TimePicker } from 'antd';
import React from 'react';
import moment from 'moment';
import * as S from './styles';
import { withTranslation } from 'react-i18next';
import { JOB_DETAILS_UI } from '../TranslationValues';

const NAMESPACES = ['JOB_DETAILS_UI'];

const ApprovalStatus = ({
    batch,
    showReschedule,
    setShowReschedule,
    newDate,
    newTime,
    handleDateChange,
    handleTimeChange,
    handleReschedule,
    handleApprove,
    handleAbort,
    users,
    t,
}) => {
    const disablePastDates = (current) => {
        return current && current < moment().startOf('day');
    };

    return (
        <S.ApprovalCard>
            <div style={{ display: 'flex', alignItems: 'flex-start', gap: '1rem' }}>
                <S.IconCircle bgColor="#41b8d5">
                    <Icon type="info-circle" style={{ fontSize: '24px', color: 'white' }} />
                </S.IconCircle>
                <S.CardContent>
                    <S.CardTitle>{t(JOB_DETAILS_UI.APPROVAL_REQUIRED.key, JOB_DETAILS_UI.APPROVAL_REQUIRED.value)}</S.CardTitle>
                    <S.CardText>
                        {t(JOB_DETAILS_UI.APPROVAL_DESCRIPTION.key, JOB_DETAILS_UI.APPROVAL_DESCRIPTION.value)}
                        {batch.approver && <span style={{ display: 'block', marginTop: '4px', fontWeight: 600 }}>{t(JOB_DETAILS_UI.APPROVER_LABEL.key, JOB_DETAILS_UI.APPROVER_LABEL.value)} {users.find(user => user.id === parseInt(batch?.approver))?.displayName || ''}</span>}
                    </S.CardText>
                    <S.ButtonGroup>
                        <S.PrimaryButton onClick={() => handleApprove()}>
                            <Icon type="check-circle" />
                            {t(JOB_DETAILS_UI.APPROVE.key, JOB_DETAILS_UI.APPROVE.value)}
                        </S.PrimaryButton>
                        <S.DarkButton onClick={() => handleAbort()}>
                            <Icon type="close-circle" />
                            {t(JOB_DETAILS_UI.ABORT.key, JOB_DETAILS_UI.ABORT.value)}
                        </S.DarkButton>
                        <S.SecondaryButton onClick={() => setShowReschedule(!showReschedule)}>
                            <Icon type="clock-circle" />
                            {showReschedule ? t(JOB_DETAILS_UI.CANCEL.key, JOB_DETAILS_UI.CANCEL.value) : t(JOB_DETAILS_UI.RESCHEDULE.key, JOB_DETAILS_UI.RESCHEDULE.value)}
                        </S.SecondaryButton>
                    </S.ButtonGroup>

                    {/* Reschedule Form */}
                    {showReschedule && (
                        <S.RescheduleForm>
                            <S.FormTitle>{t(JOB_DETAILS_UI.RESCHEDULE_JOB.key, JOB_DETAILS_UI.RESCHEDULE_JOB.value)}</S.FormTitle>
                            <S.DetailsGrid>
                                <S.DetailItem>
                                    <S.FormLabel>{t(JOB_DETAILS_UI.NEW_DATE.key, JOB_DETAILS_UI.NEW_DATE.value)}</S.FormLabel>
                                    <DatePicker
                                        style={{ width: '100%' }}
                                        value={newDate ? moment(newDate) : null}
                                        onChange={handleDateChange}
                                        disabledDate={disablePastDates}
                                    />
                                </S.DetailItem>
                                <S.DetailItem>
                                    <S.FormLabel>{t(JOB_DETAILS_UI.NEW_TIME.key, JOB_DETAILS_UI.NEW_TIME.value)}</S.FormLabel>
                                    <TimePicker
                                        style={{ width: '100%' }}
                                        value={newTime ? moment(newTime, 'HH:mm:ss') : null}
                                        onChange={handleTimeChange}
                                        disabledHours={() => {
                                            const currentHour = moment().hour();
                                            const today = moment().startOf('day');
                                            const selectedDate = newDate ? moment(newDate).startOf('day') : null;
                                            
                                            // If selected date is today, disable past hours
                                            if (selectedDate && selectedDate.isSame(today)) {
                                                return Array.from({ length: currentHour }, (_, i) => i);
                                            }
                                            return [];
                                        }}
                                    />
                                </S.DetailItem>
                            </S.DetailsGrid>
                            <S.SaveButton onClick={handleReschedule}>
                                {t(JOB_DETAILS_UI.SAVE_NEW_SCHEDULE.key, JOB_DETAILS_UI.SAVE_NEW_SCHEDULE.value)}
                            </S.SaveButton>
                        </S.RescheduleForm>
                    )}
                </S.CardContent>
            </div>
        </S.ApprovalCard>
    );
};

export default withTranslation(NAMESPACES)(ApprovalStatus);
